export default {"src":"/_next/static/media/FailedToLoadPdf.13519b9f.svg","height":448,"width":710,"blurWidth":0,"blurHeight":0};